import React from 'react'
import { useSelector } from 'react-redux'
import { LineChart } from 'components/Charts'
import { EXPERIENCE, HEADER } from 'constants/forioVariables'
import { CONSTANTS } from 'constants/constants'

const { HABILIDAD_PROMEDIO_ASISTENTES, HABILIDAD_PROMEDIO_DE_DIRECTORES } = EXPERIENCE
const { TIME } = HEADER
const { ASSISTANS, DIRECTORS } = CONSTANTS

const returnData = (variables, time) => {
  return {
    labels: time ? time[TIME] : [0],
    datasets: [
      {
        label: ASSISTANS,
        fill: false,
        borderColor: '#4bc0c0',
        data: variables[HABILIDAD_PROMEDIO_ASISTENTES],
      },
      {
        label: DIRECTORS,
        fill: false,
        borderColor: '#FFCE56',
        data: variables[HABILIDAD_PROMEDIO_DE_DIRECTORES],
      },
    ],
  }
}

const MeanAbility = () => {
  const variables = useSelector(state => state.experience.currentValues.variablesMeanAbility)
  const time = useSelector(state => state.header.variablesHeader)
  return time && time[TIME] ? (
    <LineChart data={returnData(variables, time)} titleChart="Mean Ability" />
  ) : null
}
export default MeanAbility
